<h1>Mot de passe perdu</h1>

<div class="py-4">
  <div>
    <div class="alert-success p-4">
      <h6>Votre mot de passe a été changé !</h6>
      <p>Vous pouvez dès à présent utiliser votre nouveau mot de passe pour vous connecter à votre compte</p>

    </div>

    <button [primary]="true" kendoButton class="w-100 mt-4" routerLink="/auth/login/email" type="button">Se connecter
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/components/confirm-password/confirm-password.component.html